// src/modals/getInsuranceData.js

import agronomi from "./Agronomi";
import bundlelivestock from "./Bundlelivestock";
import crop from "./Crop";
import healthadvisory from "./Healthadvisory";
import healthcard from "./Healthcard";
import healthcardwomen from "./Healthcardwomen";
import healthinsurance from "./Healthinsurance";
import incomeprotection from "./IncomeProtection";
import rsabikeinsurance from "./RsaBikeInsurance";
import rsacarinsurance from "./RsaCarInsurance";
import healthlegal from "./Healthlegal";
import legaladvisory from "./Legaladvisory";
import lifelegal from "./Lifelegal";
import lifestock from "./Lifestock";
import mobile from "./Mobile";
import veterinaryadvisory from "./Veterinaryadvisory";

const getInsuranceData = (type) => {
  switch (type) {
    case "agronomi":
      return new agronomi().getAllItems();
    case "bundlelivestock":
      return new bundlelivestock().getAllItems();
    case "crop":
      return new crop().getAllItems();
    case "healthadvisory":
      return new healthadvisory().getAllItems();
    case "healthcard":
      return new healthcard().getAllItems();
    case "healthcardwomen":
      return new healthcardwomen().getAllItems();
    case "healthinsurance":
      return new healthinsurance().getAllItems();
    case "incomeprotection":
      return new incomeprotection().getAllItems();
    case "rsabikeinsurance":
      return new rsabikeinsurance().getAllItems();
    case "rsacarinsurance":
      return new rsacarinsurance().getAllItems();
    case "healthlegal":
      return new healthlegal().getAllItems();
    case "legaladvisory":
      return new legaladvisory().getAllItems();
    case "lifelegal":
      return new lifelegal().getAllItems();
    case "lifestock":
      return new lifestock().getAllItems();
    case "mobile":
      return new mobile().getAllItems();
      case "veterinaryadvisory":
      return new veterinaryadvisory().getAllItems();
    default:
      return [];
  }
};

export default getInsuranceData;
